import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { I18n } from 'src/translations/i18n';
import { makeStyles, Button, Grid } from '@material-ui/core';

import { selectHelpCategories } from 'src/store/selectors/help';

const useStyles = makeStyles(({ palette }) => ({
  container: {
    width: '100%',
    margin: 0
  },
  button: {
    '& a': {
      color: 'inherit'
    }
  }
}));

function DetailsBottomButtons({
  seeAll,
  changeTab,
  readAll,
  changeTabIndex,
  categories
}) {
  const classes = useStyles();

  return (
    <Grid container spacing={2} justifyContent="space-between">
      {readAll && (
        <Button size="small" color="primary" onClick={seeAll} className={classes.button}>
          {I18n.t('MarkAllAsRead')}
        </Button>
      )}
      <Button size="small" color="primary" onClick={() => changeTab(categories[changeTabIndex].value)} className={classes.button}>
        <Link to="/help" href="/help">
          {I18n.t(`SeeAll${categories[changeTabIndex].label}`)}
        </Link>
      </Button>
    </Grid>
  );
}

DetailsBottomButtons.propTypes = {
  seeAll: PropTypes.func.isRequired,
  changeTab: PropTypes.func.isRequired,
  readAll: PropTypes.bool.isRequired,
  changeTabIndex: PropTypes.number.isRequired,
  categories: PropTypes.array
};

DetailsBottomButtons.defaultProps = {
  categories: []
};

const mapStateToProps = (state) => ({
  categories: selectHelpCategories(state)
});

export default connect(mapStateToProps, null)(DetailsBottomButtons);
